import axiosInstance from '@/shared/api/axios';
import type {
  ApiClientClaimedTrekIdsResponse,
  ApiClientGetItem,
  ApiClientReceiptsResponse,
  ApiClientsListParams,
  ApiClientsListResponse,
} from '@/shared/types/api/clients';

export const apiClientsGet = async (
  params: ApiClientsListParams,
): Promise<ApiClientsListResponse> => {
  const { data } = await axiosInstance.get<ApiClientsListResponse>('/auth/clients', { params });
  return data;
};

export const apiClientGet = async (id: string): Promise<ApiClientGetItem> => {
  const { data } = await axiosInstance.get<ApiClientGetItem>(`/auth/clients/${id}`);
  return data;
};

export const apiClientBlockParcelCreation = async (id: string): Promise<void> => {
  await axiosInstance.post(`/auth/clients/${id}/block-parcel-creation`);
};

export const apiClientUnblockParcelCreation = async (id: string): Promise<void> => {
  await axiosInstance.post(`/auth/clients/${id}/unblock-parcel-creation`);
};

export const apiClientClaimedTrekIdsGet = async (
  id: string,
): Promise<ApiClientClaimedTrekIdsResponse> => {
  const { data } = await axiosInstance.get<ApiClientClaimedTrekIdsResponse>(
    `/auth/clients/${id}/claimed-trek-ids`,
  );
  return data;
};

export const apiClientReceiptsGet = async (
  userId: string,
): Promise<ApiClientReceiptsResponse> => {
  const { data } = await axiosInstance.get<ApiClientReceiptsResponse>(
    `/auth/clients/${userId}/receipts`,
  );
  return data;
};
